import React from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { FormClient } from '../../dashboard/documents/exchangeOfContracts/ExchangeOfContracts.model';
import Listen from '../../dashboard/documents/buildADoc/components/Listen';
import { updateClientNameAnnotations } from '../utils';
import { UploadedDocumentState } from './useUploadedDocumentState';
import useDebounce from '@app/hooks/useDebounce';

type ClientNameListenerProps = {
    uploadedDocumentStateItems: UploadedDocumentState[];
    fieldArrayName: 'purchasers' | 'vendors';
    debounceMs?: number;
    disabled?: boolean;
    indexOffset?: number;
};

type SingleClientListenerProps = {
    fieldName: string;
    clientIndex: number;
    uploadedDocumentStateItems: UploadedDocumentState[];
};

const SingleClientListener: React.FC<SingleClientListenerProps> = ({
    fieldName,
    clientIndex,
    uploadedDocumentStateItems
}) => {
    const handleNameChange = useDebounce((newName = '') => {
        const webviewerInstances = uploadedDocumentStateItems.map(item => item.instance).filter(Boolean);
        updateClientNameAnnotations(clientIndex, newName, webviewerInstances);
    });

    return <Listen<string> activeOnly to={[fieldName]} onChange={handleNameChange} />;
};

const ClientNameListeners: React.FC<ClientNameListenerProps> = ({
    uploadedDocumentStateItems,
    fieldArrayName,
    indexOffset = 0
}) => {
    const clientsField = useFieldArray<FormClient>(fieldArrayName);

    return (
        <>
            {clientsField.fields.map((name, index) => (
                <SingleClientListener
                    key={`${fieldArrayName}-${name}`}
                    fieldName={`${name}.name`}
                    clientIndex={indexOffset + index}
                    uploadedDocumentStateItems={uploadedDocumentStateItems}
                />
            ))}
        </>
    );
};

export default ClientNameListeners;
